import React, { useState } from "react";
import { useLaunchParams } from "@telegram-apps/sdk-react";
import { ClosedPositionData } from "@crypto-trading/common/browser";
import { PageHeader } from "@/components/ui/PageHeader";
import { PositionDetailDrawer } from "@/components/PositionDetailDrawer";
import { ReferralBottomNav } from "@/components/ReferralBottomNav";
import { ClosedPositionsPanel, StatisticsCards } from "@/components/StatisticsSections";

export const StatisticsPageMobile: React.FC = () => {
  const launchParams = useLaunchParams();
  const userId = launchParams.initData?.user?.id?.toString() || "";
  const [selectedPosition, setSelectedPosition] =
    useState<ClosedPositionData | null>(null);

  return (
    <div className="flex min-h-screen flex-col">
      <div className="flex flex-1 flex-col gap-4 overflow-y-auto p-4 pb-28 [&>*]:shrink-0">
        <PageHeader
          title="Statistics"
          subtitle="Track your trading activity and performance across all exchanges."
        />
        <StatisticsCards userId={userId} mobile />
        <ClosedPositionsPanel userId={userId} mobile onSelect={setSelectedPosition} />
      </div>
      <ReferralBottomNav />
      <PositionDetailDrawer
        userId={userId}
        position={selectedPosition}
        open={!!selectedPosition}
        onOpenChange={(open) => !open && setSelectedPosition(null)}
        onPositionUpdate={(updatedPosition) =>
          setSelectedPosition(updatedPosition as ClosedPositionData)
        }
        source="positions_page"
      />
    </div>
  );
};
